import { useTableContext } from "#Contexts/TableContext"
import LoadingSpinner from "#React/ui/LoadingSpinner"

const LoadingState = ({ children, centerInContainer = false }) => {
  const { table, loading, dataSize, tableContainerRef } = useTableContext()
  if (!loading) return null
  if (dataSize > 0) return null

  if (centerInContainer) {
    return (
      <tbody className="empty-table">
        <tr>
          <td colSpan={table.getFlatHeaders().length} className="c-table__td relative">
            <div
              className="relative inset-0 flex flex-col justify-center items-center py-4 pointer-events-none"
              style={{
                left: tableContainerRef?.current ? -tableContainerRef.current.scrollLeft : 0,
                width: tableContainerRef?.current?.clientWidth || "100%",
              }}
            >
              <div className="flex items center justify-center h-48">
                {children || <LoadingSpinner />}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  return (
    <tbody className="empty-table">
      <tr>
        <td colSpan={table.getFlatHeaders().length} className="c-table__td">
          <div className="flex items center justify-center h-48">
            {children || <LoadingSpinner />}
          </div>
        </td>
      </tr>
    </tbody>
  )
}

LoadingState.propTypes = {
  children: PropTypes.node,
  centerInContainer: PropTypes.bool,
}

export default LoadingState
